<!-- ; else noEvents -->
<div class="row pb-3" *ngIf="eventList && eventList.length > 0">
  <div class="col-12 table-responsive no-gutters">
    <table class="table table-striped tbl-scrollable">
      <thead class="thead-light">
        <tr>
          <th scope="col" width="15%">Date</th>
          <th scope="col">Events</th>
        </tr>
      </thead>
      <tbody class="scroll-height-screenHeight hide-x-scroll">
        <tr *ngFor="let event of eventList; let i = index" class="pointer">
          <td scope="row" width="15%"><span *ngIf="event.date else valueNotAvailable">{{event.date | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormatHHMM : utilService.countryData.timezone}}</span></td>
          <td scope="row"><span *ngIf="event.serviceName else valueNotAvailable">{{getAction(event)}}</span>
          </td>
        </tr>
      </tbody>
    </table>
    <ng-template #valueNotAvailable>
      <span>-</span>
    </ng-template>
  </div>
  <div class="col-12 text-right">
    <span *ngIf="previousPage != null" class="pointer" (click)="getPreviousPage()">
      << Previous</span>
        <span *ngIf="nextPage != null" class="pointer" (click)="getNextPage()">&nbsp;&nbsp;&nbsp;&nbsp;Next >>
        </span>
  </div>
</div>
<ng-template #noEvents>
  <div class="row text-center my-5 text-muted no-gutters">
    <div class="col">
      <h3>No vehicle events available</h3>
    </div>
  </div>
</ng-template>